// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:30Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import RequestConfigVO from "./types/RequestConfigVO";
// @ts-ignore - not used import
import SignersVO from "./types/SignersVO";
// @ts-ignore - not used import
import PreRequestVO from "./types/PreRequestVO";
// @ts-ignore - not used import
import SignDeclineReasonVO from "./types/SignDeclineReasonVO";
// @ts-ignore - not used import
import PdfNextInitVO from "./types/PdfNextInitVO";
// @ts-ignore - not used import
import ApprovalVO from "./types/ApprovalVO";
// @ts-ignore - not used import
import BatchSignRequestVO from "./types/BatchSignRequestVO";
// @ts-ignore - not used import
import TempAttachmentVO from "./types/TempAttachmentVO";
// @ts-ignore - not used import
import SignRequestVO from "./types/SignRequestVO";
// @ts-ignore - not used import
import Type from "./types/Type";
// @ts-ignore - not used import
import VisualSignConfigVO from "./types/VisualSignConfigVO";
// @ts-ignore - not used import
import TypesCombinationVO from "./types/TypesCombinationVO";
// @ts-ignore - not used import
import GraphicSealConfigVO from "./types/GraphicSealConfigVO";
// @ts-ignore - not used import
import PdfViewVO from "./types/PdfViewVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 *  Generated from cz.marbes.qsign.controller.SignRequestInternalController.
 */
export default class SignRequestInternalApi {
    /**
     * Vytvoření dávky přes UI.
     *
     * @param data data pro vytvoření dávky
     */
    static signDocuments(data : BatchSignRequestVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.signDocuments(data, config));
    }
    /**
     * Získání počtu dokumentů, které skončili v rámci pečetění chybou
     *
     * @return 
     */
    static getSealingErrors(config?: {cancelToken?: CancelToken}) : Promise<number> {
        return unwrapResponse<number>(SignRequestInternalApi.raw.getSealingErrors(config));
    }
    /**
     * Získání konfigurace uživatelských akcí
     *
     * @return 
     */
    static getRequestConfig(config?: {cancelToken?: CancelToken}) : Promise<RequestConfigVO> {
        return unwrapResponse<RequestConfigVO>(SignRequestInternalApi.raw.getRequestConfig(config));
    }
    /**
     * Stažení přílohy.
     *
     * @param requestAttachmentId identifikátor přílohy požadavku
     * @return dokument ke stažení
     */
    static downloadRequestAttachment(requestAttachmentId : number) : string {
        // TODO serverContextPath
        const uri = (window as any).appConfig.serverContextPath + `/qsign/api/signRequestAttachment/${requestAttachmentId}/download`;
        const params = {  };
        return generateUrl(uri, params, true);
    }
    /**
     * Změna schvalujících požadavku.
     *
     * @param requestId identifikátor požadavku u kterého se mění schvalující
     * @param newApproval nová podoba schvalovacího procesu
     */
    static changeApproval(requestId : number, newApproval : ApprovalVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.changeApproval(requestId, newApproval, config));
    }
    /**
     * Vytvoření vlastní dávky přes UI.
     *
     * @param data data pro vytvoření vlastní dávky
     * @return vytvořený pohled pro prohlížečku
     */
    static ownSignDocuments(data : BatchSignRequestVO, config?: {cancelToken?: CancelToken}) : Promise<SignRequestVO> {
        return unwrapResponse<SignRequestVO>(SignRequestInternalApi.raw.ownSignDocuments(data, config));
    }
    /**
     * Označení všech dokumentů požadavku jako zpracované.
     *
     * @param requestDocumentId identifikátor dokumentu požadavku
     */
    static processRequestByDocumentId(requestDocumentId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.processRequestByDocumentId(requestDocumentId, config));
    }
    /**
     * Vyhledá dostupné kombinace typů.
     *
     * @return dostupné kombinace
     */
    static getUserCombinations(config?: {cancelToken?: CancelToken}) : Promise<TypesCombinationVO[]> {
        return unwrapResponse<TypesCombinationVO[]>(SignRequestInternalApi.raw.getUserCombinations(config));
    }
    /**
     * Vrátí přílohy dávky.
     *
     * @param requestId id dávky
     * @return 
     */
    static getRequestAttachments(requestId : number, config?: {cancelToken?: CancelToken}) : Promise<TempAttachmentVO[]> {
        return unwrapResponse<TempAttachmentVO[]>(SignRequestInternalApi.raw.getRequestAttachments(requestId, config));
    }
    /**
     * Úprava konfigurace uživatelských akcí
     *
     * @param requestConfigVO 
     * @return 
     */
    static updateRequestConfig(requestConfigVO : RequestConfigVO, config?: {cancelToken?: CancelToken}) : Promise<RequestConfigVO> {
        return unwrapResponse<RequestConfigVO>(SignRequestInternalApi.raw.updateRequestConfig(requestConfigVO, config));
    }
    /**
     * Vrátí všechny požadavky uživatele.
     *
     * @return 
     */
    static findRequests(config?: {cancelToken?: CancelToken}) : Promise<SignRequestVO[]> {
        return unwrapResponse<SignRequestVO[]>(SignRequestInternalApi.raw.findRequests(config));
    }
    /**
     * Odmítnutí všech dokumentů požadavku.
     *
     * @param pdfView identifikátor pohledu
     * @param documentView identifikátor dokumentu v pohledu
     * @param reason důvod odmítnutí
     */
    static declineAllSignDocument(pdfView : string, documentView : string, reason : SignDeclineReasonVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.declineAllSignDocument(pdfView, documentView, reason, config));
    }
    /**
     * Získání konfigurace grafické podoby pečeti
     *
     * @return 
     */
    static getGraphicSeal(config?: {cancelToken?: CancelToken}) : Promise<GraphicSealConfigVO> {
        return unwrapResponse<GraphicSealConfigVO>(SignRequestInternalApi.raw.getGraphicSeal(config));
    }
    /**
     * Vytvoří pohled dokumentu.
     *
     * @param requestDocumentId identifikátor zobrazovaného dokumentu
     * @return 
     */
    static getPdfViewDocument(requestDocumentId : number, config?: {cancelToken?: CancelToken}) : Promise<PdfViewVO> {
        return unwrapResponse<PdfViewVO>(SignRequestInternalApi.raw.getPdfViewDocument(requestDocumentId, config));
    }
    /**
     * Smazání požadavku.
     *
     * @param requestId identifikátor požadavku
     */
    static deleteSignRequest(requestId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.deleteSignRequest(requestId, config));
    }
    /**
     * Získání seznamu dostupných fontů pro vizuální podpis.
     *
     * @return 
     */
    static getAvailableFonts(config?: {cancelToken?: CancelToken}) : Promise<string[]> {
        return unwrapResponse<string[]>(SignRequestInternalApi.raw.getAvailableFonts(config));
    }
    /**
     * Stažení podepsaných dokumentů v požadavku jako zip.
     *
     * @param requestId identifikátor požadavku
     * @return zip podepsaných dokumentů
     */
    static downloadSignRequestAsZip(requestId : number) : string {
        // TODO serverContextPath
        const uri = (window as any).appConfig.serverContextPath + `/qsign/api/signRequest/${requestId}/download/zip`;
        const params = {  };
        return generateUrl(uri, params, true);
    }
    /**
     * Odmítnutí jednoho dokument požadavku.
     *
     * @param pdfView identifikátor pohledu
     * @param documentView identifikátor dokumentu v pohledu
     * @param reason důvod odmítnutí
     */
    static declineSignDocument(pdfView : string, documentView : string, reason : SignDeclineReasonVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.declineSignDocument(pdfView, documentView, reason, config));
    }
    /**
     * Úprava konfigurace vizuálního podpisu
     *
     * @param signConfigVO 
     * @return 
     */
    static updateVisualSign(signConfigVO : VisualSignConfigVO, config?: {cancelToken?: CancelToken}) : Promise<VisualSignConfigVO> {
        return unwrapResponse<VisualSignConfigVO>(SignRequestInternalApi.raw.updateVisualSign(signConfigVO, config));
    }
    /**
     * Stažení dokumentu.
     *
     * @param requestDocumentId identifikátor dokumentu požadavku
     * @return dokument ke stažení
     */
    static downloadRequestDocument(requestDocumentId : number) : string {
        // TODO serverContextPath
        const uri = (window as any).appConfig.serverContextPath + `/qsign/api/signRequestDocument/${requestDocumentId}/download`;
        const params = {  };
        return generateUrl(uri, params, true);
    }
    /**
     * Označení dokumentu jako zpracovaný.
     *
     * @param requestDocumentId identifikátor dokumentu požadavku
     */
    static processRequestDocument(requestDocumentId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.processRequestDocument(requestDocumentId, config));
    }
    /**
     * 
     *
     * @param uuid 
     * @return 
     */
    static getRequestByUuid(uuid : string, config?: {cancelToken?: CancelToken}) : Promise<SignRequestVO> {
        return unwrapResponse<SignRequestVO>(SignRequestInternalApi.raw.getRequestByUuid(uuid, config));
    }
    /**
     * Inicializace dalšího dokumentu v požadavku.
     *
     * @param pdfView identifikátor pohledu
     * @return 
     */
    static nextInitDocument(pdfView : string, config?: {cancelToken?: CancelToken}) : Promise<PdfNextInitVO> {
        return unwrapResponse<PdfNextInitVO>(SignRequestInternalApi.raw.nextInitDocument(pdfView, config));
    }
    /**
     * Vytvoření dávky přes UI.
     *
     * @param preRequestId 
     * @param data data pro vytvoření dávky
     */
    static createRequestByPreRequest(preRequestId : number, data : BatchSignRequestVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.createRequestByPreRequest(preRequestId, data, config));
    }
    /**
     * 
     *
     * @param uuid 
     * @return 
     */
    static getPreRequestByUuid(uuid : string, config?: {cancelToken?: CancelToken}) : Promise<PreRequestVO> {
        return unwrapResponse<PreRequestVO>(SignRequestInternalApi.raw.getPreRequestByUuid(uuid, config));
    }
    /**
     * Vytvoří pohled dokumentu.
     *
     * @param requestId identifikátor dávky zobrazovaného dokumentu
     * @param type 
     * @param selectUnsigned 
     * @param approval 
     * @return 
     */
    static getPdfView(requestId : number, type : Type, selectUnsigned : boolean, approval : boolean, config?: {cancelToken?: CancelToken}) : Promise<PdfViewVO> {
        return unwrapResponse<PdfViewVO>(SignRequestInternalApi.raw.getPdfView(requestId, type, selectUnsigned, approval, config));
    }
    /**
     * Úprava konfigurace grafické pečeti
     *
     * @param graphicSealConfig 
     * @return 
     */
    static updateGraphicSeal(graphicSealConfig : GraphicSealConfigVO, config?: {cancelToken?: CancelToken}) : Promise<GraphicSealConfigVO> {
        return unwrapResponse<GraphicSealConfigVO>(SignRequestInternalApi.raw.updateGraphicSeal(graphicSealConfig, config));
    }
    /**
     * Storno dokumentů na požadavku.
     *
     * @param requestId identifikátor požadavku
     */
    static stornoSignRequest(requestId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.stornoSignRequest(requestId, config));
    }
    /**
     * Získání konfigurace vizuálního podpisu
     *
     * @return 
     */
    static getVisualSign(config?: {cancelToken?: CancelToken}) : Promise<VisualSignConfigVO> {
        return unwrapResponse<VisualSignConfigVO>(SignRequestInternalApi.raw.getVisualSign(config));
    }
    /**
     * Spuštění opětovného pečetění u spadlých dávek
     *
     */
    static repeatFailedSealings(config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.repeatFailedSealings(config));
    }
    /**
     * Změna podepisujících na požadavku.
     *
     * @param requestId identifikátor požadavku u kterého se mění podepisující
     * @param newSignersPersonIds identifikátory nových pracovníků, ktěří budou podepisovat
     * @return 
     */
    static changeSignPerson(requestId : number, newSignersPersonIds : SignersVO, config?: {cancelToken?: CancelToken}) : Promise<SignRequestVO> {
        return unwrapResponse<SignRequestVO>(SignRequestInternalApi.raw.changeSignPerson(requestId, newSignersPersonIds, config));
    }
    /**
     * 
     *
     * @param preRequestId 
     */
    static stornoPreSignRequest(preRequestId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignRequestInternalApi.raw.stornoPreSignRequest(preRequestId, config));
    }

    static raw = {
            signDocuments: function(data : BatchSignRequestVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/sign`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, data, finalConfig);
            },
            getSealingErrors: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number>> {
                const uri = `/qsign/api/signRequest/getSealingErrors`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<number>>(finalUri, finalConfig);
            },
            getRequestConfig: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<RequestConfigVO>> {
                const uri = `/qsign/api/signRequest/getRequestConfig`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<RequestConfigVO>>(finalUri, finalConfig);
            },
            changeApproval: function(requestId : number, newApproval : ApprovalVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${requestId}/changeApprovers`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, newApproval, finalConfig);
            },
            ownSignDocuments: function(data : BatchSignRequestVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignRequestVO>> {
                const uri = `/qsign/api/signRequest/sign/own`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignRequestVO>>(finalUri, data, finalConfig);
            },
            processRequestByDocumentId: function(requestDocumentId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${requestDocumentId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
            getUserCombinations: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TypesCombinationVO[]>> {
                const uri = `/qsign/api/types/combinations/user`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<TypesCombinationVO[]>>(finalUri, finalConfig);
            },
            getRequestAttachments: function(requestId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TempAttachmentVO[]>> {
                const uri = `/qsign/api/signRequestAttachments/${requestId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<TempAttachmentVO[]>>(finalUri, finalConfig);
            },
            updateRequestConfig: function(requestConfigVO : RequestConfigVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<RequestConfigVO>> {
                const uri = `/qsign/api/signRequest/updateRequestConfig`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<RequestConfigVO>>(finalUri, requestConfigVO, finalConfig);
            },
            findRequests: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignRequestVO[]>> {
                const uri = `/qsign/api/signRequest`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<SignRequestVO[]>>(finalUri, finalConfig);
            },
            declineAllSignDocument: function(pdfView : string, documentView : string, reason : SignDeclineReasonVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/decline/all`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, reason, finalConfig);
            },
            getGraphicSeal: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<GraphicSealConfigVO>> {
                const uri = `/qsign/api/signRequest/getGraphicSeal`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<GraphicSealConfigVO>>(finalUri, finalConfig);
            },
            getPdfViewDocument: function(requestDocumentId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<PdfViewVO>> {
                const uri = `/qsign/api/signRequestDocument/pdfView/${requestDocumentId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<PdfViewVO>>(finalUri, finalConfig);
            },
            deleteSignRequest: function(requestId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${requestId}/delete`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
            getAvailableFonts: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<string[]>> {
                const uri = `/qsign/api/visualSign/fonts`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<string[]>>(finalUri, finalConfig);
            },
            declineSignDocument: function(pdfView : string, documentView : string, reason : SignDeclineReasonVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${pdfView}/${documentView}/decline`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, reason, finalConfig);
            },
            updateVisualSign: function(signConfigVO : VisualSignConfigVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<VisualSignConfigVO>> {
                const uri = `/qsign/api/visualSign/update`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<VisualSignConfigVO>>(finalUri, signConfigVO, finalConfig);
            },
            processRequestDocument: function(requestDocumentId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequestDocument/${requestDocumentId}/process`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
            getRequestByUuid: function(uuid : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignRequestVO>> {
                const uri = `/qsign/api/signRequest/detail/${uuid}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<SignRequestVO>>(finalUri, finalConfig);
            },
            nextInitDocument: function(pdfView : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<PdfNextInitVO>> {
                const uri = `/qsign/api/signRequest/${pdfView}/nextInit`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<PdfNextInitVO>>(finalUri, finalConfig);
            },
            createRequestByPreRequest: function(preRequestId : number, data : BatchSignRequestVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/preRequest/${preRequestId}/createRequest`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, data, finalConfig);
            },
            getPreRequestByUuid: function(uuid : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<PreRequestVO>> {
                const uri = `/qsign/api/preRequest/detail/${uuid}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<PreRequestVO>>(finalUri, finalConfig);
            },
            getPdfView: function(requestId : number, type : Type, selectUnsigned : boolean, approval : boolean, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<PdfViewVO>> {
                const uri = `/qsign/api/signRequest/pdfView/${requestId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { type, selectUnsigned, approval };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<PdfViewVO>>(finalUri, finalConfig);
            },
            updateGraphicSeal: function(graphicSealConfig : GraphicSealConfigVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<GraphicSealConfigVO>> {
                const uri = `/qsign/api/signRequest/updateGraphicSeal`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<GraphicSealConfigVO>>(finalUri, graphicSealConfig, finalConfig);
            },
            stornoSignRequest: function(requestId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/${requestId}/storno`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
            getVisualSign: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<VisualSignConfigVO>> {
                const uri = `/qsign/api/visualSign`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<VisualSignConfigVO>>(finalUri, finalConfig);
            },
            repeatFailedSealings: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/signRequest/repeatFailedSealings`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, any>(finalUri, finalConfig);
            },
            changeSignPerson: function(requestId : number, newSignersPersonIds : SignersVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignRequestVO>> {
                const uri = `/qsign/api/signRequest/${requestId}/changeSignPerson`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignRequestVO>>(finalUri, newSignersPersonIds, finalConfig);
            },
            stornoPreSignRequest: function(preRequestId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/preSignRequest/${preRequestId}/storno`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
    }
}
